module.exports = {"Operate19":{"daobanList":[{"title":"1:正副本均遗失还是遗失其中之一","values":[{"name":"均遗失","xuanzhong":1,"cailiaoList":[{"name":"1、报纸公告样张（已在国家企业信用信息公示系统公示营业执照作废声明的不需提交）","state":"非必要"},{"name":"2、《增、减、补、换发证照申请书》","state":"必要"}]},{"name":"遗失其中之一","xuanzhong":1,"cailiaoList":[{"name":"1、报纸公告样张（已在国家企业信用信息公示系统公示营业执照作废声明的不需提交）","state":"非必要"},{"name":"2、《增、减、补、换发证照申请书》","state":"必要"},{"name":"3、已领取纸质版营业执照的缴回营业执照正、副本（遗失除外）；已领取外国（地区）企业常驻代表机构登记证、代表证的缴回登记证、代表证（遗失除外）","state":"必要"}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-19.json
// module id = 1276
// module chunks = 0